module.exports = __webpack_public_path__ + "img/image172.baa627eb.jpg";